export * from './src/infinite-scroll-trigger.module';
